import React from "react";

const OperatorDetailOverview: React.FC<{}> = (props) => {
	return <div></div>;
};

export default OperatorDetailOverview;
